module.exports = __webpack_public_path__ + "static/media/infinitec-logo.c67d2dc9.jpeg";